import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Global route-change scroll reset.
 *
 * React Router preserves the window scroll position across `<Link>`
 * navigations by default. That's the right behaviour for "back" and
 * SPA-internal anchors but it's confusing for footer / header link
 * clicks — the user clicks "Contact Us" from the bottom of the page
 * and the new page mounts already-scrolled to the bottom, making it
 * look like nothing happened.
 *
 * Mount this once inside the Router so every pathname change snaps the
 * viewport back to (0, 0). `behavior: "auto"` is intentional — a smooth
 * scroll on every navigation reads as sluggish on cross-page links and
 * fights with the page's own entrance animations.
 *
 * Honors React Router's own scroll-restore semantics for the back/
 * forward buttons (history `POP` actions) by leaving them alone: a
 * user who hit Back expects to land at their previous scroll position,
 * not at the top.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}
